export default "__VITE_ASSET__Bp1WzRlC__"